import Layout from '../components/Layout/Layout.js';
import Login from '../container/Login/Login.js';

import Auth from '../components/Auth/Auth';
import Quote from '../pages/quote/index.jsx';
import Setting from '../pages/setting/index.jsx';
import Account from '../pages/account/index.jsx';
import Home from '../pages/home/index.jsx';
import Manage from '../pages/manage/index.jsx';
import Order from '../pages/order/index.jsx';
import Email from '../pages/email/index.jsx';
import ErrorLog from '../pages/errorLog/index.jsx';
import ReferralCode from '../pages/referralCode/index.jsx';
import ManualWebhook from '../pages/manualWebhook/index.jsx';



let routes = [
  {
    path: '/',
    element: 
      <Auth>
        <Layout/>
      </Auth>,
    children: [
      { path: '/layout/home', element: <Home/>},
      { path: '/layout/order', element: <Order/>},
      { path: '/layout/quote', element: <Quote/>},
      { path: '/layout/email', element: <Email/>},
      { path: '/layout/error-log', element: <ErrorLog/>},
      { path: '/layout/setting', element: <Setting/>},
      { path: '/layout/account', element: <Account/>},
      { path: '/layout/manage', element: <Manage/>},
      { path: '/layout/referral-code', element: <ReferralCode/>},
      { path: '/layout/manual-webhook', element: <ManualWebhook/>}
    ]
  },
  {
    path: '/login',
    element: <Login/>
  }
];


export default routes;